export default __webpack_public_path__ + "static/media/crisBarros_logo.03b32804.svg";